import React from "react";
import { PageHeader } from "CommonComponent";
import './User.css';
import { UserList } from "./component";

const User = () => {
  return (
    <div>
      <PageHeader title="All Users" />
      <UserList />
    </div>
  );
};

export default User;
